<template>
  <Icon>
    <svg slot="svg" width="70px" height="70px" viewBox="0 0 70 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Logowanie-/-Rejestracja" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Rejestracja-sukces" transform="translate(-690.000000, -322.000000)" fill="#43CEA2" fill-rule="nonzero">
          <g id="Group-4" transform="translate(490.000000, 194.000000)">
            <g id="icons/form-success" transform="translate(200.000000, 128.000000)">
              <path d="M35,0.14 C15.6680522,0.14 0,15.7766533 0,35.0698597 C0,54.3632064 15.6680522,69.9997194 35,69.9997194 C54.3319478,69.9997194 70,54.3630661 70,35.0698597 C70,15.776513 54.3319478,0.14 35,0.14 Z M35,67.2053307 C17.2457229,67.2053307 2.8,52.7885571 2.8,35.0697194 C2.8,17.3508818 17.2457229,2.9342485 35,2.9342485 C52.7544177,2.9342485 67.2,17.351022 67.2,35.0697194 C67.2,52.7885571 52.7544177,67.2053307 35,67.2053307 Z" id="Shape"></path>
              <polygon id="Shape" points="53.025 21.3495792 29.5066867 44.8221643 16.9886345 32.332004 15.0008032 34.315992 29.5066867 48.79 54.9991968 23.3334269"></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsSucceededIcon",
  components: {
    Icon
  },
  extends: Icon
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-succeeded-icon.vue